import React from "react";
import { BackSvg } from "../../svgFile";
import { useNavigate } from "react-router-dom";
import { usePage } from "../../PageContext";

const PageName = () => {
  const navigate = useNavigate();
  const { pageName } = usePage();
  return (
    <div className="position-relative mb-5 d-xl-block d-none">
      <div className="back-icon fixed-back-icon" onClick={() => navigate(-1)}>
        <BackSvg />
      </div>
      <div className="page-name text-center">
        <h3 className="mb-0">
          {pageName}
        </h3>
      </div>
    </div>
  );
};

export default PageName;
